import { PaginationModel } from "utils/PaginationType";
import { Voucher } from "./VoucherType";
import { Delete, Edit } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { formatDate, formatPrice } from "utils/helper";
import { SearchVoucherParams } from "./VoucherManagement";

export const VoucherTableColumns = (
  fetchVouchers: (page: number, pageSize: number, search: SearchVoucherParams) => Promise<any>, 
  paginationModel: PaginationModel, 
  handleEdit: (voucher: Voucher) => void, 
  handleDelete: (voucher: Voucher) => void
) => {
  return [
    { field: 'id', headerName: 'ID', width: 100, flex: 1 },
    { field: 'name', headerName: 'Tên', width: 100, flex: 1 },
    { field: 'code', headerName: 'Code', width: 100, flex: 1 },
    { field: 'discountValue', headerName: 'Giảm giá', width: 100, flex: 1, renderCell: (params: any) => {
      return formatPrice(params.row.discountValue);
    } },
    { field: 'startDate', headerName: 'Ngày bắt đầu', width: 100, flex: 1, renderCell: (params: any) => {
      return formatDate(new Date(params.row.startDate));
    } },
    { field: 'endDate', headerName: 'Ngày kết thúc', width: 100, flex: 1, renderCell: (params: any) => {
      return formatDate(new Date(params.row.endDate));
    } },
    { field: 'maxCount', headerName: 'Số lượng tối đa', width: 100, flex: 1, renderCell: (params: any) => {
      return params.row.maxCount || "Không giới hạn";
    } },
    { field: 'usageCount', headerName: 'Số lượng đã đổi', width: 100, flex: 1, renderCell: (params: any) => {
      return params.row.usageCount;
    } },
    { field: 'actions', headerName: 'Hành động', width: 100, flex: 1, renderCell: (params: any) => {
      return <>
      <IconButton color="primary" onClick={() => handleEdit(params.row)}>
        <Edit />
      </IconButton>
      <IconButton color="error" onClick={() => handleDelete(params.row)}>
        <Delete />
      </IconButton>
      </>
    } },
  ];
};

export const VoucherTypeOptions = {
  DISCOUNT: 'Giảm giá',
  FREE_SHIPPING: 'Miễn phí vận chuyển',
}

export const VoucherStatusOptions = {
  ACTIVE: 'Hoạt động',
  INACTIVE: 'Không hoạt động',
}

export const VoucherDiscountTypeOptions = {
  PERCENTAGE: 'Phần trăm',
  FIXED: 'Giá trị cố định',
}